import { message } from 'antd'
import { useCallback } from 'react'

export const useYellow = (isYellow: boolean) => {
  const validateYellow = useCallback((): boolean => {
    if (isYellow) {
      message.destroy()
      message.error('图片涉嫌违规')

      return false
    }

    return true
  }, [isYellow])

  return {
    validateYellow,
  }
}
